export function countCompanyItems(): void {
  const companyWrapper = document.querySelector('.js-countCompanyItems');
  if (companyWrapper instanceof HTMLElement) {
    const length = companyWrapper.querySelectorAll('.js-companyItem').length;
    companyWrapper.classList.add('company__preview--' + length);
  }
}
